import { render, staticRenderFns } from "./memberHistoric.vue?vue&type=template&id=2acb08ea&scoped=true"
import script from "./memberHistoric.vue?vue&type=script&lang=js"
export * from "./memberHistoric.vue?vue&type=script&lang=js"
import style0 from "./memberHistoric.vue?vue&type=style&index=0&id=2acb08ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2acb08ea",
  null
  
)

export default component.exports